function useOperatingSystem() {
  const platform = navigator.platform.toLowerCase();
  const isMacOs = platform.includes('mac');
  const isWindows = platform.includes('win');

  return { isMacOs, isWindows };
}

export default useOperatingSystem;
